import script from "./debitor-index.vue?vue&type=script&setup=true&lang=js"
export * from "./debitor-index.vue?vue&type=script&setup=true&lang=js"

import "./debitor-index.vue?vue&type=style&index=0&id=88d0c384&lang=css"

const __exports__ = script;

export default __exports__